import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useTranslation } from 'react-i18next';
import { UserReport } from '../data';
import usePlayerSelector from '../utils/usePlayerSelector';
import formatErrorForReport from '../utils/formatErrorForReport';

export default function ComponentErrorFallback({ error }) {
    const { t: translate } = useTranslation();
    const { authState: { accessToken } } = useOktaAuth();
    const { PlayerID, FullName, Team } = usePlayerSelector();

    useEffect(() => {
        if (window.location.host.split('.')[0] === 'base') {
            const report = {
                Type: 8,
                Url: window.location.href,
                UserAgent: window.navigator.userAgent,
                Subject: 'Error occurred in Player Portal',
                ConsoleErrors: formatErrorForReport(error),
                LoggedInPlayerId: PlayerID,
                LoggedInPlayerName: FullName,
                LoggedInPlayerTeam: Team?.FullName,
                LanguageDisplayed: translate('languageNameEnglish'),
            };

            const fd = new FormData();
            fd.append('UserReport', JSON.stringify(report));
            UserReport.post(accessToken, fd);
        }
        if (window.webkit?.messageHandlers?.dugoutLog) {
            window.webkit.messageHandlers.dugoutLog.postMessage({
                message: `${PlayerID}|${FullName}|${window.location.hash}|${formatErrorForReport(error)}`,
                fileName: `errorboundary.${(new Date()).toISOString().substring(0, 10)}`,
                logLevel: 'ERROR',
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div data-export-error={formatErrorForReport(error)}>
            <p>{translate('components.error-fallback.error-message')}</p>
        </div>
    );
}
